import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const TourPackagesTab = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const tourPackages = [
  {
    id: 1,
    title: 'Goa Beach Paradise - 4D/3N',
    operator: 'Coastal Adventures Pvt Ltd',
    packageType: 'Beach Holiday',
    submissionDate: '2024-10-26',
    status: 'pending',
    destination: 'Goa',
    price: '₹15,999 per person',
    thumbnail: "https://images.unsplash.com/photo-1628180003161-06c825c0f1f6",
    documents: ['Travel License', 'Insurance Policy', 'Hotel Partnerships'],
    complianceScore: 82,
    flaggedIssues: ['Insurance coverage verification pending'],
    duration: '4 Days / 3 Nights',
    inclusions: ['Accommodation', 'Breakfast', 'Airport Transfer'],
    rating: 4.3
  },
  {
    id: 2,
    title: 'Himalayan Trekking Expedition',
    operator: 'Mountain Trails India',
    packageType: 'Adventure',
    submissionDate: '2024-10-25',
    status: 'under_review',
    destination: 'Himachal Pradesh',
    price: '₹22,500 per person',
    thumbnail: "https://images.unsplash.com/photo-1611279829519-fe00940f18c9",
    documents: ['Adventure Tourism License', 'Safety Equipment Certificate', 'Guide Credentials'],
    complianceScore: 95,
    flaggedIssues: [],
    duration: '7 Days / 6 Nights',
    inclusions: ['Accommodation', 'All Meals', 'Trekking Guide', 'Equipment'],
    rating: 4.7
  },
  {
    id: 3,
    title: 'Rajasthan Royal Heritage Tour',
    operator: 'Heritage India Tours',
    packageType: 'Cultural',
    submissionDate: '2024-10-24',
    status: 'approved',
    destination: 'Rajasthan',
    price: '₹35,000 per person',
    thumbnail: "https://images.unsplash.com/photo-1716731348131-643b344bff30",
    documents: ['Tour Operator License', 'Heritage Site Permissions', 'Luxury Hotel Tie-ups'],
    complianceScore: 98,
    flaggedIssues: [],
    duration: '8 Days / 7 Nights',
    inclusions: ['Luxury Accommodation', 'All Meals', 'Private Guide', 'Transport'],
    rating: 4.8
  }];


  const statusColumns = [
  { id: 'pending', label: 'Pending Review', color: 'yellow' },
  { id: 'under_review', label: 'Under Verification', color: 'blue' },
  { id: 'approved', label: 'Approved', color: 'green' },
  { id: 'rejected', label: 'Rejected', color: 'red' }];


  const filteredPackages = tourPackages?.filter((tourPackage) => {
    if (filter !== 'all' && tourPackage?.status !== filter) return false;
    if (searchQuery && !tourPackage?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) &&
    !tourPackage?.operator?.toLowerCase()?.includes(searchQuery?.toLowerCase())) return false;
    return true;
  });

  const getPackagesByStatus = (status) => {
    return filteredPackages?.filter((tourPackage) => tourPackage?.status === status);
  };

  const handleApprove = (tourPackage) => {
    console.log('Approving tour package:', tourPackage?.id);
  };

  const handleReject = (tourPackage) => {
    console.log('Rejecting tour package:', tourPackage?.id);
  };

  return (
    <div className="flex h-full">
      {/* Main Content */}
      <div className={`transition-all duration-300 ${selectedPackage ? 'flex-1' : 'w-full'}`}>
        {/* Filters */}
        <div className="p-6 border-b border-border bg-card">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <Input
                placeholder="Search tour packages or operators..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full" />

            </div>
            <Select
              value={filter}
              onValueChange={setFilter}
              className="w-full sm:w-48">

              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="under_review">Under Review</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </Select>
            <div className="flex gap-2">
              <Button variant="outline" size="sm">
                <Icon name="Filter" size={16} />
              </Button>
              <Button variant="outline" size="sm">
                Bulk Actions
              </Button>
            </div>
          </div>
        </div>

        {/* Kanban Board */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">
            {statusColumns?.map((column) =>
            <div
              key={column?.id}
              className="bg-muted/30 rounded-lg p-4 h-full">

                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-foreground">{column?.label}</h3>
                  <span className={`px-2 py-1 rounded text-xs font-medium bg-${column?.color}-100 text-${column?.color}-800`}>
                    {getPackagesByStatus(column?.id)?.length}
                  </span>
                </div>

                <div className="space-y-3">
                  {getPackagesByStatus(column?.id)?.map((tourPackage) =>
                <div
                  key={tourPackage?.id}
                  onClick={() => setSelectedPackage(tourPackage)}
                  className="bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow">

                      <div className="flex items-start gap-3">
                        <img
                      src={tourPackage?.thumbnail}
                      alt={tourPackage?.title}
                      className="w-12 h-12 rounded object-cover flex-shrink-0" />

                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm text-foreground truncate">
                            {tourPackage?.title}
                          </h4>
                          <p className="text-xs text-muted-foreground truncate">
                            {tourPackage?.operator}
                          </p>
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs text-primary font-medium">
                              {tourPackage?.packageType}
                            </span>
                            <div className="flex items-center gap-1">
                              <Icon name="Star" size={10} className="text-yellow-500 fill-current" />
                              <span className="text-xs text-muted-foreground">
                                {tourPackage?.rating}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Price and Duration */}
                      <div className="mt-3 flex items-center justify-between text-xs">
                        <span className="font-medium text-foreground">{tourPackage?.price}</span>
                        <span className="text-muted-foreground">{tourPackage?.duration}</span>
                      </div>

                      {/* Destination */}
                      <div className="mt-2">
                        <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
                          <Icon name="MapPin" size={10} />
                          {tourPackage?.destination}
                        </span>
                      </div>

                      {/* Compliance Score */}
                      <div className="mt-2 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${
                      tourPackage?.complianceScore >= 90 ? 'bg-green-500' :
                      tourPackage?.complianceScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`
                      } />
                          <span className="text-xs text-muted-foreground">
                            {tourPackage?.complianceScore}% compliant
                          </span>
                        </div>
                        <span className="text-xs text-muted-foreground">
                          {tourPackage?.submissionDate}
                        </span>
                      </div>

                      {/* Quick Actions */}
                      {tourPackage?.status === 'pending' &&
                  <div className="mt-3 flex gap-2">
                          <Button
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleApprove(tourPackage);
                      }}>

                            <Icon name="Check" size={12} />
                            Approve
                          </Button>
                          <Button
                      variant="outline"
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReject(tourPackage);
                      }}>

                            <Icon name="X" size={12} />
                            Reject
                          </Button>
                        </div>
                  }

                      {/* Flagged Issues */}
                      {tourPackage?.flaggedIssues?.length > 0 &&
                  <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
                          <div className="flex items-center gap-1">
                            <Icon name="AlertTriangle" size={12} className="text-red-500" />
                            <span className="text-xs text-red-700">
                              {tourPackage?.flaggedIssues?.[0]}
                            </span>
                          </div>
                        </div>
                  }
                    </div>
                )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Detail Panel */}
      {selectedPackage &&
      <div className="w-96 bg-card border-l border-border p-6 overflow-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">Package Details</h3>
            <Button
            variant="ghost"
            size="sm"
            onClick={() => setSelectedPackage(null)}>

              <Icon name="X" size={16} />
            </Button>
          </div>

          <div className="space-y-6">
            {/* Package Info */}
            <div>
              <img
              src={selectedPackage?.thumbnail}
              alt={selectedPackage?.title}
              className="w-full h-32 object-cover rounded-lg" />

              <div className="mt-3">
                <h4 className="font-medium text-foreground">
                  {selectedPackage?.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  Operator: {selectedPackage?.operator}
                </p>
                <div className="grid grid-cols-2 gap-2 mt-3 text-sm">
                  <div>
                    <span className="text-muted-foreground">Type:</span>
                    <span className="font-medium ml-1">{selectedPackage?.packageType}</span>
                  </div>
                  <div>
                    <span className="text-muted-foreground">Duration:</span>
                    <span className="font-medium ml-1">{selectedPackage?.duration}</span>
                  </div>
                  <div className="col-span-2">
                    <span className="text-muted-foreground">Price:</span>
                    <span className="font-medium ml-1 text-primary">{selectedPackage?.price}</span>
                  </div>
                </div>
                <div className="flex items-center gap-4 mt-3">
                  <div className="flex items-center gap-1">
                    <Icon name="MapPin" size={14} className="text-muted-foreground" />
                    <span className="text-sm text-foreground">{selectedPackage?.destination}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Star" size={14} className="text-yellow-500 fill-current" />
                    <span className="text-sm font-medium">{selectedPackage?.rating}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Package Inclusions */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Package Inclusions</h5>
              <div className="space-y-2">
                {selectedPackage?.inclusions?.map((inclusion, index) =>
              <div key={index} className="flex items-center gap-2">
                    <Icon name="Check" size={14} className="text-green-500 flex-shrink-0" />
                    <span className="text-sm text-foreground">{inclusion}</span>
                  </div>
              )}
              </div>
            </div>

            {/* License & Compliance */}
            <div>
              <h5 className="font-medium text-foreground mb-3">License & Compliance</h5>
              <div className="space-y-2">
                {selectedPackage?.documents?.map((doc, index) =>
              <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-foreground">{doc}</span>
                    <Icon name="CheckCircle" size={16} className="text-green-500" />
                  </div>
              )}
              </div>
              
              {/* Compliance Score */}
              <div className="mt-4 p-3 bg-muted rounded-lg">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Compliance Score</span>
                  <span className="text-lg font-bold text-primary">
                    {selectedPackage?.complianceScore}%
                  </span>
                </div>
                <div className="w-full bg-border rounded-full h-2 mt-2">
                  <div
                  className={`h-2 rounded-full ${
                  selectedPackage?.complianceScore >= 90 ? 'bg-green-500' :
                  selectedPackage?.complianceScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`
                  }
                  style={{ width: `${selectedPackage?.complianceScore}%` }} />

                </div>
              </div>
            </div>

            {/* Flagged Issues */}
            {selectedPackage?.flaggedIssues?.length > 0 &&
          <div>
                <h5 className="font-medium text-foreground mb-3">Issues to Resolve</h5>
                <div className="space-y-2">
                  {selectedPackage?.flaggedIssues?.map((issue, index) =>
              <div key={index} className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded">
                      <Icon name="AlertTriangle" size={14} className="text-red-500 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-700">{issue}</span>
                    </div>
              )}
                </div>
              </div>
          }

            {/* Submission History */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Submission History</h5>
              <div className="text-sm text-muted-foreground">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Calendar" size={12} />
                  Submitted on {selectedPackage?.submissionDate}
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="User" size={12} />
                  Assigned to Tourism Board Verification
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <Button className="w-full">
                <Icon name="Check" size={16} />
                Approve Package
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="X" size={16} />
                Reject Package
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="MessageCircle" size={16} />
                Request Documents
              </Button>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default TourPackagesTab;